import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createTimeTrackingActivityEntityInfo } from 'record-it-time-common/entity/entities/TimeTrackingActivity/createTimeTrackingActivityEntityInfo';
import { TimeTrackingActivity } from './timeTrackingActivityTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export const timeTrackingActivityEntityInfo =
  createTimeTrackingActivityEntityInfo<TimeTrackingActivity>({
    additionalFieldInfos:
      EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
  });
